import type { WagsAgentChatStatus } from "./wags-agent-chat";

export function isTurnActive(status: WagsAgentChatStatus): boolean {
    return status === "submitted" || status === "streaming";
}

export function shouldShowGlobalLoader({
    status,
    engaged,
    turnHasVisibleAssistantOutput,
}: {
    status: WagsAgentChatStatus;
    engaged: boolean;
    turnHasVisibleAssistantOutput: boolean;
}): boolean {
    if (!engaged) return false;
    if (turnHasVisibleAssistantOutput) return false;
    return isTurnActive(status);
}
